<adapt-catchups-page-content *ngIf="team"
                             [team]="team"></adapt-catchups-page-content>
